import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminHeader from "./admin/common/header/adminHeader";
import AdminSidebar from "./admin/common/sidebar/adminSidebar";
import AdminFooter from "./admin/common/footer/adminFooter";
import { useDispatch, useSelector } from "react-redux";
import { setMobileSidebar } from "../core/data/redux/commonSlice";
import '../style/icons/themify/themify.css'
import '../style/icons/tabler-icons/tabler-icons.css'
import axios from "axios";
const AdminFeature = () => {
  const dispatch = useDispatch();
  const [loggedIn, setLoggedIn] = useState(false);
  const expandMenu = useSelector((state: any) => state.commonSlice.expandMenu);
  const miniSidebar = useSelector(
    (state: any) => state.commonSlice.miniSidebar
  );
  const mobileSidebar = useSelector(
    (state: any) => state.commonSlice.mobileSidebar
  );
    const toggleMobileSidebar = () => {
      dispatch(setMobileSidebar(!mobileSidebar));
    };

  const navigate = useNavigate();

  async function checkLogin() {
    const token = localStorage.getItem('aToken'); // assuming token is stored after login
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}admin/checkLogin`,
        {},
         {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );
      // Handle success
      const data = response.data;
       if (data.status === 1) {
        // its fine login
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
        // localStorage.setItem('aToken', data.token);
        navigate("/admin/login");
      }
    } catch (error: any) {
      console.error('Login error:', error.message);
      navigate("/admin/login");
      // alert(error?.response?.data?.message || 'Login again.');
    }
  }

  useEffect(() => {
    checkLogin();
  }, [])
   
  return (
    <>
      <div
        className={`${!expandMenu && miniSidebar ? "expand-menu" : ""} ${miniSidebar ? "mini-sidebar" : ""}`}
      >
        {loggedIn ? (
          <>
            <div className={`main-wrapper ${mobileSidebar ? "slide-nav" : ""}`}>
              <AdminHeader />
              <AdminSidebar />
              <div className="page-wrapper">
                <Outlet />
                <AdminFooter />
              </div>
            </div>
            <div className={`sidebar-overlay ${mobileSidebar ? "opened" : ""}`}  onClick={toggleMobileSidebar}></div>
          </>
        ) : (
          <div className="alert alet-danger">Please Login to continue.</div>
        )}
        </div>
    </>
  );
};

export default AdminFeature;
